import { createApp, watch } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import i18n from './i18n'
import './styles/main.css'

const app = createApp(App)

app.use(createPinia())
app.use(router)
app.use(i18n)

app.mount('#app')

// 监听语言变化，同步更新 html lang
document.documentElement.lang = i18n.global.locale.value
watch(
  () => i18n.global.locale.value,
  (locale) => {
    document.documentElement.lang = locale
  }
)
